import React from 'react';
import {
  Image,
  Text,
  View,
} from 'react-native';
import { img_check } from '../../../../utils/ImagesManagementUtils';
import { Service_fee_recipient } from '../../../../utils/DictionaryManagementUtils';
import { textSecondary_7_5 } from '../TextComponent/TextStyle';
//= ========================================================================

const IconWithTextLine = ({
  globJSON, simPlatform,
}) => {
  const { colors } = globJSON.configurations.theme;
  const myStyles = {
    iconLineView: {
      flexWrap: 'wrap',
      flexDirection: 'row',
      alignItems: 'center',
    },
    checkIconStyle: {
      width: 11,
      height: 11,
      backgroundColor: colors.primary_cta_color,
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 0 : 6,
    },
    blueIcon: {
      width: 10,
      height: 10,
      fontFamily: 'SFProText',
      fontSize: 11.6,
      fontWeight: 500,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      tintColor: colors.cta_font_color,
      margin: 'auto',
    },

  };
  return (
    <View
      style={myStyles.iconLineView}
    >
      <View style={myStyles.checkIconStyle}>
        <Image
          style={myStyles.blueIcon}
          source={img_check}
        />
      </View>

      <Text style={[textSecondary_7_5(globJSON, simPlatform), { padding: 4 }]}>
        {Service_fee_recipient}
      </Text>
    </View>
  );
};
export default IconWithTextLine;
